import React from 'react'
import { withRouter } from 'react-router-dom'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBAlert, MDBRow, MDBCol, MDBBtn, MDBInput } from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import TextEditor from '../../components/shared/TextEditor/TextEditor.component'
import MessageEditor from './../../components/messaging/MessageEditor/MessageEditor.component'
import { MessagesList, Store } from './../../components/messaging'
import getQueryParams from '../../shared/utilities/getQueryParams.function'
import MessagingEditor from './MessagingEditor.component'

class ManageMessagesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabName: 'messages',
    }
  }

  componentDidMount() {}

  isEditing = () => {}

  isActive = tabName => {}

  changeTab = (tabName, event) => {
    if (!this.isEditing()) this.setState(prevState => ({ ...prevState, tabName }))
  }

  renderTab = () => {
    return <MessagesList category={this.state.tabName} />
  }

  /*
  renderTabs ()
  {
    return (
        <ul
          className="nav nav-tabs md-tabs"
          id="myTabMD"
          role="tablist"
        >
          <li className="nav-item waves-effect waves-light">
            <MDBBtn type='button' color='default'
              className={`nav-link ${(this.isActive('messages') ? 'active' : '')}`}
              onClick={event => this.changeTab('messages',event)}
            >
              Message Board
            </MDBBtn>
          </li>
          <li className="nav-item waves-effect waves-light">
            <MDBBtn type='button' color='default'
              className={`nav-link ${(this.isActive('alerts') ? 'active' : '')}`}
              onClick={event => this.changeTab('alerts',event)}
            >
              Alerts
            </MDBBtn>
          </li>
          <li className="nav-item waves-effect waves-light">
            <MDBBtn type='button' color='default'
              className={`nav-link ${(this.isActive('leaders') ? 'active' : '')}`}
              onClick={event => this.changeTab('leaders',event)}
            >
              Leader Messages
            </MDBBtn>
          </li>
        </ul>
      )
  }
  */

  render() {
    return (
      <DashboardLayout>
        <main id='ManageMessagesPage' className='mainSection mt-5 pb-5'>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol size='12'>
                <h2>Manage Messaging</h2>
                <hr />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size='12'>
                <MessagingEditor />
                {/*
                  <section className="mx-2 pt-4">
                    {this.renderTabs()}
                    <div className="tab-content card pt-5">
                      {this.renderTab()}
                    </div>
                  </section>
                  */}
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default withRouter(ManageMessagesPage)
